import * as React from "react";
import {useEffect, useState} from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import "./styles.scss";
import {handleNavigation, routePaths, setIndexPath} from "loan-application/routes";
import {getRoutes} from "loan-application/routes";
import {IProfile} from "StateInterface";
import {getLamProfile, getLatestApplicationStatus, saveLamProfile} from "profile/api";
import {setLamProfile, setLatestApplicationStatus} from "profile/actions";
import Loading from "components/loading";
import {defaultErrorMessage, getLoanApplicationDocs, getPrefillDocs, paramToProfile} from "loan-application/utils";
import {ContainerBox} from "myshubhlife-component/container-box";
import {CC_EMAIL_ID, COLOR} from "utils/variables";
import BasicCard from "myshubhlife-component/card";
import {imageBaseUrl, websiteUrl} from "config";
import RenderOtp from "loan-application/OTP";
import {getAllowNewApplication, getCompanyInfo} from "loan-application/apiCall";
import {getAvailableDocs} from "documents/api";
import {setPrefillDocs} from "documents/actions";
import {ILatestStatus} from "profile/interface";
import { isWebview } from "utils";
import { getIdToken } from "service";

interface IConnectProps {
    dispatch?: (action: any) => void;
    isAndroid: boolean;
    userId: number;
    authExt: {[key: string]: string};
    profile: IProfile;
    latestApplicationStatus: ILatestStatus;
}
const notAllowNewApplicationText = `Sorry! Your loan application is under process
                                    and you won’t be able to apply for a new loan.`;
function LoanApplication(props: IConnectProps & RouteComponentProps) {
    useEffect(() => {
        if (!props.isAndroid) {
            let allQuery;
            if (props.authExt && Object.keys(props.authExt).length) {
                allQuery = Object.keys(props.authExt)
                    .map((key) => `${key}=${props.authExt[key]}`)
                    .join("&");
            }
            location.replace(`${websiteUrl}/loan-application/#/${allQuery ? "?" + allQuery : ""}`);
        }    
    }, []);
    
    const [errorMsg, setErrorMsg] = useState<string>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [showOtp, setShowOtp] = useState(false);
    const [isPrefilling, setIsPrefilling] = useState(false);
    const [isNewApplicationAllowed, setIsNewApplicationAllowed] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState({
      currentEmployer: (props.profile && props.profile["currentEmployer"]) || "",
      workCin: (props.profile && props.profile["workCin"]) || ""});
    const {utm_source, utm_campaign, utm_medium, emp_id, phone, sourcingCode} = props.authExt;
    useEffect(() => {
        setIndexPath(props.match.url);
        setLoading(true);
        (async () => {
            try {
                const [profile, latestStatus, newAppAllowStatus] =
                await Promise.all([getLamProfile(), getLatestApplicationStatus(), getAllowNewApplication()]);
                setIsNewApplicationAllowed(newAppAllowStatus.isAllowNewApplication);
                if (props.authExt.currentEmployer || utm_source) {
                    await getCurrentEmployer();
                }
                if (latestStatus && profile) {
                    props.dispatch(setLamProfile(profile));
                    props.dispatch(setLatestApplicationStatus(latestStatus));
                    getAvailableDocs(props.userId, getLoanApplicationDocs)
                        .then((resp) => {
                            if (resp && resp.length) {
                                props.dispatch(setPrefillDocs(getPrefillDocs(resp, latestStatus?.latestStatusUpdateTime)));
                            }
                        });
                    if (props.authExt) {
                        setIsPrefilling(true);
                    }
                }
            } catch (error) {
                setLoading(false);
                setErrorMsg("Something went wrong!");
            }
        })();
        handleNavigation(routePaths.ELIGIBILITY_PAGE);
    }, []);
    useEffect(() => {
        if (props.authExt && isPrefilling) {
            const paramProfile = paramToProfile(props.authExt, props.profile);
            updateLamProfile(paramProfile);
        }
    }, [isPrefilling]);
    const getCurrentEmployer = async () => {
        try {
            let currentEmployer = props.authExt.currentEmployer || utm_source;
            currentEmployer = currentEmployer.split("_").join(" ");
            const response =  await getCompanyInfo(currentEmployer.replace("&", "%26"));
            if (response.status) {
                response.data.hits.hit.map((item) => {
                    if (item.fields.name === currentEmployer) {
                        setSelectedCompany({
                            currentEmployer,
                            workCin: item.fields.cin,
                        });
                    }
                });
            }
        } catch (error) {
            setLoading(false);
            setErrorMsg("Something went wrong!");
        }
    };
    const updateLamProfile = async (paramProfile) => {
        const utmParams = { source: utm_source, medium: utm_medium, campaign: utm_campaign };
        const profileToBeSend = {
            ...props.profile,
            ...paramProfile,
            currentEmployer: selectedCompany.currentEmployer,
            workCin: selectedCompany.workCin,
        };
        setLoading(true);
        try {
            const response = await saveLamProfile(props.userId, profileToBeSend, sourcingCode || utm_source, utmParams);
            if (response.status === 200) {
                const res = await getLamProfile();
                if (res) {
                    props.dispatch(setLamProfile(res));
                    setLoading(false);
                    setIsPrefilling(false);
                }
            }
        } catch (error) {
            setLoading(false);
            setIsPrefilling(false);
        }
    };

    const renderNotAllowedNewApplicationMessage = () => {
        return (
            <ContainerBox backgroundColor={COLOR.WHITE}>
                <BasicCard>
                <div className="status-message-container">
                    <div>
                        <img src={`${imageBaseUrl}/img/ic_application_in_progress.svg`} alt="processing-icon"/>
                    </div>
                        {notAllowNewApplicationText}
                    <br/>Email us at&nbsp;
                    <a href={`mailto: ${CC_EMAIL_ID}`} style={{color: COLOR.PRIMARY}}>
                        {CC_EMAIL_ID}
                    </a> for any queries.
                </div>
            </BasicCard>
        </ContainerBox>);
    };
    const showOtpField = () => {
        return ((props.profile && !props.profile.mobileOtpVerified)
        || (phone && props.profile.mobile !== phone));
    };
    return (
        <React.Fragment>
            {
                errorMsg &&
                <ContainerBox backgroundColor={COLOR.WHITE}>
                    {defaultErrorMessage(errorMsg)}
                </ContainerBox>
            }
            {
                props.profile && !errorMsg && !loading && !isPrefilling ?
                    isNewApplicationAllowed ?
                        getRoutes(props.match.path) :
                        renderNotAllowedNewApplicationMessage() :
                    <Loading active={loading}/>
            }
        </React.Fragment>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        isAndroid: state.login.isAndroid,
        userId: state.login.auth.userId,
        authExt: state.login.authExt,
        profile: state.profileInfo.profile,
        latestApplicationStatus: state.profileInfo.latestStatus,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(LoanApplication);
